import { HttpError, IResourceComponentsProps, useParsed, useNavigation } from "@refinedev/core";
import { Edit, useForm, ListButton, ShowButton } from "@refinedev/mantine";
import { Select, Textarea, Flex } from "@mantine/core";
import { TeaAddonProblem } from "entities/tea_addon_problem";

export type UpdateTeaAddonProblem = {
  state: string;
  notes: string;
};

const stateOptions = [
  { value: "pending", label: "Pending" },
  { value: "fixing", label: "Fixing" },
  { value: "fixed", label: "Fixed" },
];

export const SanityCheckersEdit: React.FC<IResourceComponentsProps> = () => {
  const { id } = useParsed();
  const { show } = useNavigation();
  const {
    getInputProps,
    saveButtonProps,
    refineCore: { queryResult },
  } = useForm<TeaAddonProblem, HttpError, UpdateTeaAddonProblem>({
    initialValues: {
      state: "pending",
      notes: "",
    },
    refineCoreProps: {
      resource: "tea_addon_problems",
      id: id,
      redirect: false,
      onMutationSuccess: (data, variables, context) => {
        if (id) {
          show("sanity_checkers", id);
        }
      },
    },
  });

  const problem = queryResult?.data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      headerButtons={
        <Flex gap="sm">
          <ListButton resource="sanity_checkers" />
          {problem && (
            <ShowButton resource="sanity_checkers" recordItemId={problem.id} />
          )}
        </Flex>
      }
    >
      <Select
        label="State"
        data={stateOptions}
        {...getInputProps("state")}
      />
      <Textarea
        label="Notes"
        placeholder="Enter notes about this problem"
        minRows={4}
        {...getInputProps("notes")}
      />
    </Edit>
  );
};

